import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { EmailShareButton, LinkedinShareButton, TwitterShareButton, FacebookShareButton } from 'react-share'
import { MdChevronLeft } from 'react-icons/md'
import { IoPaperPlaneSharp } from 'react-icons/io5'
import { FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa'

const BlogSidebar = ({ location }) => {
	const { site } = useStaticQuery(query)
	const url = site.url + location.pathname

	const iconClassName = 'text-3xl <md:text-xl hover:text-orange transition-colors'

	return (
		<aside
			className="flex md:flex-col md:items-center gap-y-8 <md:justify-between md:self-start md:sticky-top"
			style={{ '--offset': '1rem' }}
		>
			<Link
				className="flex items-center md:border-b <md:border-r border-grounding-navy/10 <md:pr-4 hover:text-orange transition-colors"
				to="/blog"
				title="Back to blog listing"
			>
				<MdChevronLeft className="text-5xl <md:text-3xl" />
				<span className="md:hidden">Back</span>
			</Link>

			<EmailShareButton url={url}>
				<IoPaperPlaneSharp className={iconClassName} />
			</EmailShareButton>

			<LinkedinShareButton url={url}>
				<FaLinkedin className={iconClassName} />
			</LinkedinShareButton>

			<TwitterShareButton url={url}>
				<FaTwitter className={iconClassName} />
			</TwitterShareButton>

			<FacebookShareButton url={url}>
				<FaFacebook className={iconClassName} />
			</FacebookShareButton>
		</aside>
	)
}

export default BlogSidebar

const query = graphql`query BlogSidebar {
	site: sanitySite {
		url
	}
}`
